import React, { useState } from "react";

// import "../../styles/forgetpassword.css";
import "./Login.scss";
import axios from "axios";
import { useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
// import IconButton from "@mui/material/IconButton";
// import InputAdornment from "@mui/material/InputAdornment";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ReactComponent as CMSLOGO } from "../../images/CMS_UMS_LOGO.svg";
import { useNavigate } from "react-router-dom";
// import { color } from "@mui/system";

function ForgotPassword() {
  const dispatch = useDispatch();
  const [string, setString] = useState("");
  const [EmailID, setEmailID] = useState("");
  // const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loginFail, setLoginFail] = useState(false);
  const [notAuth, setNotAuth] = useState(false);
  const [errormsg, setErrorMsg] = useState("");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

  var regex = new RegExp(/[@]/g);
  let boolen = regex.test(string);

  const [buttonclickd, setButtonclickddd] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (EmailID.trim() === "") {
      setErrorMsg("Please enter the email.");
      return;
    }

    if (!emailPattern.test(EmailID)) {
      setErrorMsg("Please enter a valid email.");
      return;
    }

    try {
      const resp = await axios.put("auth/forgotpassword", { email: EmailID }, {
        headers: { "content-type": "application/json" },
      });
     // Temporary password generated successfully
      if (resp.status === 200) {
        dispatch(loginReducer.Forget_password(false));
        console.log("vinith", resp.data.message)
        if( resp.data.message==="Temporary password generated successfully"){
          toast.success(resp.data.message, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
       
      }
    } catch (err) {
      console.log(err);
      // dispatch(sidebarReducer.apiLoad(false));

      toast.error(err.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };


  const validateinput = () => {
    if (EmailID === "") {
      setErrorMsg("Please enter Email.");
    } else if (EmailID !== "") {
      const inputElement = document.getElementById("EmailID");
      const inputValue = inputElement.value;
      const sanitizedValue = inputValue.replace(/\s/g, "");
      inputElement.value = sanitizedValue;
      setErrorMsg("");
      setButtonclickddd(true);
    }
  };

  // const handleClickShowPassword = () => {
  //   setShowPassword(!showPassword);
  // };

  // const handleMouseDownPassword = (event) => {
  //   event.preventDefault();
  // };
  const navigate = useNavigate();

  return (
    <div className="login-page">
  
      <ToastContainer />
      <div
        className="container-fluid g-0 m-0 p-0"
        style={{ overflow: "hidden" }}
      >
        <div className="row">
          <CMSLOGO
            style={{
              width: "30px",
              height: "auto",
              position: "absolute",
              top: "40px",
              left: "60px",
            }}
          />
        </div>

        <div className="row ">
          <div className="col-lg-6 col-md-6  col-sm-12 col-one">
            <div style={{ marginTop: "11%", marginLeft: "70px" }}>
              <form onSubmit={handleSubmit}>
                <div className="forget-text">Forgot Password ?</div>
                <div className="enter-details">Please enter your details</div>

                <Box
                  //component="form"
                  sx={{
                    "& > :not(style)": { width: "459px" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <br></br>
                  <div className="EmailID-field" style={{color: "#FFFFFF"}} >Email</div>
                  <TextField
                    id="EmailID"
                    placeholder="Enter the Email ID"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    value={EmailID}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        background: "#1A1A1A",
                        border: "1px solid #262626",
                        borderRadius: "10px",
                      },

                      "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover": {
                        "& > fieldset": {
                          borderColor: "#262626",
                          border: "1px solid",
                          borderRadius: "5px",
                        },
                      },
                    }}
                    InputProps={{
                      style: {
                        height: "47px",
                        color: "#FFFFFF",
                      },
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      setEmailID(value);
                      setLoginFail(false);
                      setNotAuth(false);
                    }}
                  // style={{ backgroundColor: "grey" }}
                  />
                </Box>

                <button
                  className="generatepassword"
                  type="submit"
                  onClick={validateinput}
                >
                  Generate Password
                </button>
                {errormsg && (
                  <p style={{ color: "red", fontSize: "15px", marginTop: "10px" }}>{errormsg}</p>
                )}

                {/*   {buttonclickd && (
                  <p style={{ color: "green", fontSize: "20px" }}>
                    Password generated successfully!
                  </p>
                )} */}
                <div
                  style={{ marginTop: "5px" }}
                  className="back-login"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Back to login
                </div>
                <br></br>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
